const getters = {
  isLoading: state => state.app.isLoading,
  userInfo: state => state.app.userInfo,
  tokenState: state => state.app.tokenState,
  defaultBabyInfo: state => state.app.defaultBabyInfo,
  defaultChildInfo: state => state.app.defaultChildInfo,
  saveFlag: state => state.app.saveFlag,
  roles: state => state.user.roles,
  country: state => state.app.country
}
export default getters
